import {action, makeObservable, observable, runInAction} from "mobx";
import {message, notification} from "antd";
import {request} from "@/framework/network/request";

export default class OrderStore {
    loading: boolean
    orderList: any
    total: number

    constructor() {
        makeObservable(this, {
            loading: observable,
            orderList: observable,
            total: observable,

            getOrderList: action,
            setTotal: action,
        })
        this.loading = false;
        this.orderList = []
        this.total = 0
    }

    setOrderListNull(state: number, order: any) {
        runInAction(() => {
            this.loading = true
            if (state === 0) {
                this.orderList = []
            } else {
                this.orderList.push(order)
            }
        })
        runInAction(() => {
            this.loading = false
        })
    }

    setTotal(total: number) {
        runInAction(() => {
            this.loading = true
            this.total = total
        })
        runInAction(() => {
            this.loading = false
        })
    }

    // 获取订单列表
    getOrderList = async (page: number = 0, size: number = 10) => {
        try {
            runInAction(() => {
                this.loading = true
            })
            const res = await request.get(`/orders`, {page, size})
            if (res && res.status === 1) {
                this.setTotal(res.data.totalElements)
                res.data.content.forEach(
                    (item: any) => {
                        const commodity = item.commodity?.map(
                            (it: any) => {
                                return {
                                    title: it.productName,
                                    property: it.skuAttr1ValueName + '/' + it.skuAttr2ValueName,
                                    key: it.id,
                                    price: it.price,
                                    quantity: it.number,
                                    titleFile: it.picture,
                                }
                            }
                        )
                        let ite = {
                            id: item.orderId,
                            orderPayment: '' + item.orderPayment,
                            orderState: item.orderState,
                            orderTime: item.orderTime.replace("T", " "),
                            productList: commodity
                        }
                        if (item.orderState === "ENABLE") {
                            ite.orderState = "订单已支付"
                        } else if (item.orderState === "DISABLE") {
                            ite.orderState = "订单已失效"
                        } else {
                            ite.orderState = "订单未支付"
                        }
                        this.setOrderListNull(1, ite)
                    }
                )

                // this.orderList = [
                //   {
                //     id: Math.random() * 100 + 12,
                //     name: '商铺名称',
                //     productList: tempList
                //   },
                //   {
                //     id: Math.random() * 100 + 12,
                //     name: '商铺名称',
                //     productList: tempList
                //   }
                // ]
            } else {
                await message.error('系统错误请重试', 2)
            }
            runInAction(() => {
                this.loading = false
            })
        } catch (e) {
            this.loading = false
            notification.error({
                message: '获取商品信息错误',
                description: e.message
            })
        }
    }

}